/**
 * An agent's knowledge-base cutoff, `config.kbMinSimilarity` (design §6): how
 * close a search result must be to the caller's question before the agent uses
 * it. The scale is the agent function's (supabase/functions/_shared/agents/
 * config.ts, which refuses anything off it) — change both together.
 */

export const KB_MIN_SIMILARITY_DEFAULT = 0.55;
export const KB_MIN_SIMILARITY_MIN = 0.4;
export const KB_MIN_SIMILARITY_MAX = 0.8;
export const KB_MIN_SIMILARITY_STEP = 0.05;

/** 0.40, 0.45 … 0.80, as the function rounds them. */
const STEPS = Array.from({ length: 9 }, (_, step) => (8 + step) / 20);

/** The agent's stored value when it is on the scale; anything else (none, or no config at all)
 * is the default, as the bot reads it. */
export function kbMinSimilarityOf(config: object | null | undefined): number {
  const stored = config && "kbMinSimilarity" in config ? config.kbMinSimilarity : undefined;
  return STEPS.find((step) => step === stored) ?? KB_MIN_SIMILARITY_DEFAULT;
}
